import { type ReactNode } from "react";

interface BadgeProps {
  className?: string;
  label: string;
  icon?: ReactNode;
  color?: "yellow" | "orange";
}

const bg: Record<string, string> = {
  yellow: "#FBAC00",
  orange: "#FF7900",
};

export function Badge({ className = "", label, icon, color = "yellow" }: BadgeProps) {
  return (
    <div
      className={`inline-flex items-center shrink-0 cursor-default select-none ${className}`}
      style={{ gap: 8, padding: "10px 12px", borderRadius: 12, backgroundColor: bg[color] }}
    >
      {icon && <span style={{ width: 20, height: 20, flexShrink: 0, position: "relative" }}>{icon}</span>}
      <span
        style={{
          fontFamily: "var(--font-commissioner)",
          fontWeight: 600,
          fontStyle: "normal",
          fontSize: 16,
          lineHeight: "20px",
          color: "white",
          letterSpacing: "-0.32px",
          whiteSpace: "nowrap",
          fontVariationSettings: '"FLAR" 0, "VOLM" 0',
        }}
      >
        {label}
      </span>
    </div>
  );
}
